import { Entity } from '../entity';
import { UUID } from '../uuid/entity';

export interface MitigationProps {
    id: string;
    name?: string;
    label: string;
    description: string;
    url?: string;
    srcId?: string;
    isCustom?: boolean;
}

export type NewMitigationProps = Omit<MitigationProps, 'id'>;

export class Mitigation extends Entity {
    label: string;
    description: string;
    url?: string;
    srcId?: string;
    isCustom?: boolean;

    constructor({
        id,
        name,
        label,
        description,
        url,
        srcId,
        isCustom,
    }: MitigationProps) {
        super({ id, name });
        this.label = label;
        this.description = description;
        this.url = url;
        this.srcId = srcId;
        this.isCustom = isCustom;
    }

    static new({
        name,
        label,
        description,
        url,
        srcId,
        isCustom,
    }: NewMitigationProps): Mitigation {
        const id = new UUID();
        return new Mitigation({
            id: id.toString(),
            name,
            label,
            description,
            url,
            srcId,
            isCustom,
        });
    }
}
